export default "__VITE_ASSET__zTAE4jpo__"